module.exports = __webpack_public_path__ + "static/img/picture@2x.5c40229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/picture@2x.png
// module id = s+FW
// module chunks = 44